// Leaf module: the dialog index and the steps import each other, so a field id either of
// them reads while being evaluated has to come from here rather than through that cycle.
export const AGENCY_ID_OVERRIDE_FIELD_ID = 'agency_id_override';

export const AGENCY_ID_MAX_LENGTH = 256;
